import React from "react";
import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";
import useLink from "@qpr/client-api-base/hooks/useLink";
import Tabs from "design/components/toolbar/Tabs";
import PeriodSelector from "components/PeriodSelector";
import SplitView from "design/layouts/SplitView";
import Center from "design/layouts/Center";
import Right from "design/layouts/Right";
import ToolbarContainer from "design/components/toolbar/ToolbarContainer";
import ToolbarTitle from "design/components/texts/ToolbarTitle";
import useCurrentUser from "@qpr/client-api-base/context/UserContext";

const WorkflowAdminToolbar = (props: { selected?: string }) => {
  const ctx = useAppContext();
  const link = useLink();
  const user = useCurrentUser();
  return (
    <ToolbarContainer>
      <SplitView partCnt={3}>
        <ToolbarTitle>Workflow Admin</ToolbarTitle>
        <Center>
          <Tabs
            onChange={(value) => {
              link({
                page: value,
              });
            }}
            selected={props.selected || ctx.page || ""}
            options={[
              {
                viewName: "workflowadmin",
                title: "Workflow Status",
              },
              ...(user.profile?.tenantAdmin
                ? [
                    {
                      viewName: "workflowconfigs",
                      title: "Configuration",
                    },
                  ]
                : []),
            ]}
          />
        </Center>
        <Right>
          <PeriodSelector level="Month" />
        </Right>
      </SplitView>
    </ToolbarContainer>
  );
};

export default WorkflowAdminToolbar;
